import Config from "./config";

export function initFacebookSdk() {
	window.fbAsyncInit = function () {
		window.FB.init({
			appId: Config.facebookAppId(),
			xfbml: true,
			version: "v17.0",
		});
		window.FB.AppEvents.logPageView();
	};

	(function (d, s, id) {
		var js,
			fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) {
			return;
		}
		js = d.createElement(s);
		js.id = id;
		js.src = "https://connect.facebook.net/en_US/sdk.js";
		fjs.parentNode.insertBefore(js, fjs);
	})(document, "script", "facebook-jssdk");
}
